<template>
    <div class="q10__hotspot-richmedia" :style="{
            backgroundImage: 'url(images/commons/hotspot_richmedia__' + (options.icon || 'default') + '.png)'
        }">
        <template v-if=" options.collection[0].type === 'link' ">
            <a :href=" options.collection[0].src " class="block w-full h-full" target="_blank"></a>
        </template>

        <template v-else>
            <div class="block h-full w-full" @click="handlerClick()"></div>
        </template>
    </div>
</template>

<script>
import RichmediaMixin from "../mixins/RichmediaMixin";

export default {
    name: "HotspotRichmedia",
    mixins: [
        RichmediaMixin
    ],
    props: {
        options: null,
    },
    methods: {
        handlerClick() {
            let vm = this;

            let resources = this.options.collection || [];

            // console.log(resources);

            if (resources.length) {
                this.richmediaShowDiaporama(resources);
            }

            $eventbus.$emit('gtag', {
                method:'event',
                action: 'hotspot-richmedia',
                params:{
                    event_category : 'general',
                    event_label : 'hotspot-richmedia',
                    value : vm.$route.fullPath,
                }
            });
        }
    },
}
</script>

<style scoped lang="scss">
.q10__hotspot-richmedia {
    @apply absolute block z-10;
    @apply w-10 md:w-12 lg:w-12;
    @apply h-10 md:h-12 lg:h-12;
    @apply bg-no-repeat bg-contain;
    @apply cursor-pointer;

}
</style>

<style lang="scss">


.fancybox__container.richmedia-diaporama {

    .fancybox__viewport {
        background: #c6c6c6;

        .fancybox__content::before{
            content: "✕";
                    position: absolute !important;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    top: -47px !important;
                    right: 0px !important;
                    color: var(--fancybox-color, #fff);
                    width: 39px;
                    height: 48px;
                    /* background-color: red; */
                    text-align: center;
                    font-size: 26px;
                    font-weight: 100;
                    pointer-events: none;
        }
    }

    .fancybox__thumbs {
        background: #000;

        .fancybox__thumb {
            &:after {
            }
        }
    }

}
    .carousel__button[disabled] {
            display: none;
    }
    .carousel__button {
            display: none;
    }
    .carousel__button[data-fancybox-close]  {
        display: none;
    }
</style>
